module.exports = __webpack_public_path__ + "static/img/noStore.03cb6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noStore.png
// module id = xHf+
// module chunks = 18